import parseTraffic from './traffic'
import parseCustomerType from './customer-type'
import parsePayment from './payment'
import { parseChannel, parseNonInteractiveChannel, parseInteractiveChannel } from './channel'
import { statusOptions } from '@/common/demand'
import {
  testStatus,
  categories
} from '@/common/material-metadata'
import { fmtTime as parseTime, fmtSize, fmtMoney, fmtPercent, fmtSeconds, fmtThousands } from '../../../common/utils/data-format.js'

export {
  parseTraffic,
  parseCustomerType,
  parsePayment,
  parseChannel,
  parseNonInteractiveChannel,
  parseInteractiveChannel,
  parseTime,
  fmtSize,
  fmtMoney,
  fmtPercent,
  fmtSeconds,
  fmtThousands
}

export function parseTestStatus(status) {
  const item = testStatus.find(e => {
    return e.value === Number(status)
  })
  if (item) {
    return item.label
  }
  return '-'
}

export function parseOrientation(status) {
  switch (Number(status)) {
    case 1:
      return '横屏'
    case 2:
      return '竖屏'
    case 3:
      return '自适应'
    default:
      return '-'
  }
}

export function parseIsPlayable(status) {
  switch (Number(status)) {
    case 1:
      return '否'
    case 2:
      return '是'
    default:
      return '未审核'
  }
}

export function parseUserStatus(status) {
  switch (Number(status)) {
    case 1:
      return '正常'
    case 2:
      return '禁用'
    default:
      return '未激活'
  }
}

export function parseExtPlayable(status) {
  switch (Number(status)) {
    case 0:
      return '总激励视频Normal'
    case 1:
      return '视频+通用endcard'
    case 2:
      return '视频+交互素材'
    case 3:
      return '仅交互素材'
    default:
      return '-'
  }
}

export function parsePriority(status) {
  switch (Number(status)) {
    case 1:
      return '低'
    case 2:
      return '中'
    case 3:
      return '高'
    case 4:
      return '紧急'
    default:
      return '-'
    // no default
  }
}

export function parseBUGState(status) {
  switch (Number(status)) {
    case 1:
      return '待解决'
    case 2:
      return '已确认'
    case 3:
      return '研发驳回'
    case 4:
      return '待验证'
    case 5:
      return '测试驳回'
    case 6:
      return '已解决'
    default:
      return '-'
  }
}

export function parseDemandState(status) {
  const statusItem = statusOptions.find(e => {
    return e.value === status
  })
  if (statusItem) {
    return statusItem.label
  }
  return '-'
}

export function parseCategory(status) {
  const item = categories.find(e => {
    return e.value === status
  })
  if (item) {
    return item.label
  }
  return '-'
}

export function parseBUGAction(status) {
  const actions = {
    create: '创建BUG',
    confirm: '研发确认',
    reject: '研发驳回',
    active: 'QA重新提交',
    fix: '提交验证',
    reopen: '测试驳回',
    resolve: '已解决',
    undo: '撤销操作'
  }
  return actions[status] || status
}

export function fmLastDay(time) {
  if ((String(time)).length === 10) {
    time = Number(time) * 1000
  }
  const temTime = (90 * 86400) - (new Date().getTime() - time)
  switch (true) {
    case temTime / 86400 >= 1:
      return `${parseInt(temTime / 86400, 10)}天`
    case temTime / 3600 >= 1:
      return `${parseInt(temTime / 3600, 10)}小时`
    case temTime / 60 >= 1:
      return `${parseInt(temTime / 60, 10)}分钟`
    default:
      return `0天`
  }
}

export function fmtQuery(obj) {
  if (typeof obj === 'object') {
    const numKey = ['page', 'page_size']
    const data = JSON.parse(JSON.stringify(obj))
    for (const i in data) {
      if (numKey.indexOf(i) !== -1) {
        data[i] = Number(data[i])
      }
    }
    return data
  }
  console.error('传参并不是对象类型')
  return null
}

// eslint-disable-next-line consistent-return
export function sortByName(v1, v2) {
  let a = v1.name || v1.filename
  let b = v2.name || v2.filename
  const reg = /[0-9]+/g
  const lista = a.match(reg)
  const listb = b.match(reg)
  if (!lista || !listb) {
    return a.localeCompare(b)
  }
  for (let i = 0, minLen = Math.min(lista.length, listb.length); i < minLen; i++) {
    // 数字所在位置序号
    const indexa = a.indexOf(lista[i])
    const indexb = b.indexOf(listb[i])
    // 数字前面的前缀
    const prefixa = a.substring(0, indexa)
    const prefixb = a.substring(0, indexb)
    // 数字的string
    const stra = lista[i]
    const strb = listb[i]
    // 数字的值
    const numa = parseInt(stra, 10)
    const numb = parseInt(strb, 10)
    // 如果数字的序号不等或前缀不等，属于前缀不同的情况，直接比较
    if (Number(indexa) !== Number(indexb) || Number(prefixa) !== Number(prefixb)) {
      return a.localeCompare(b)
    } else if (stra === strb) {
      // 如果是最后一个数字，比较数字的后缀
      if (Number(i) === Number(minLen) - 1) {
        return a.substring(indexa).localeCompare(b.substring(indexb))
      }
      // 如果不是最后一个数字，则循环跳转到下一个数字，并去掉前面相同的部分
      a = a.substring(indexa + stra.length)
      b = b.substring(indexa + stra.length)
    } else if (Number(numa) === Number(numb)) { // 如果数字的string不全等，但值相等
      // 直接比较数字前缀0的个数，多的更小
      return strb.lastIndexOf(String(numb)) - stra.lastIndexOf(String(numa))
    }
    // 如果数字不等，直接比较数字大小
    return numa - numb
  }
}

export function fmtDollar(value) {
  return fmtMoney(value, 2, '.', ',', '$')
}

export function fmtECpm(value) {

}

export function fmtRevenue(value) {
  return '$' + fmtMoney((value / 1000).toFixed(2))
}

export function parseOS(os) {
  const platform = {
    ios: 'iOS',
    android: 'Android'
  }
  return platform[os] || os
}
